import { apiClient } from '@/app/core/services/apiClient.service';
import { BaseApiService } from '@/app/shared/services/apis/baseApi.service';

class ParticipantIdentifiersApiService extends BaseApiService {
    getList(mainEventId) {
        return this.client.get(`main-events/${mainEventId}/participant-identifiers`);
    }

    create(mainEventId, eventId, payload) {
        return this.client.post(`main-events/${mainEventId}/participant-identifiers`, payload);
    }

    update(mainEventId, participantIdentifierId, payload) {
        return this.client.patch(
            `main-events/${mainEventId}/participant-identifiers/${participantIdentifierId}`,
            payload
        );
    }

    remove(mainEventId, participantIdentifierId) {
        return this.client.delete(
            `main-events/${mainEventId}/participant-identifiers/${participantIdentifierId}`
        );
    }

    setForGuests(mainEventId, payload) {
        return this.client.post(
            `main-events/${mainEventId}/participant-identifiers/set-for-guests`,
            payload
        );
    }
}

export const participantIdentifiersApi = new ParticipantIdentifiersApiService(apiClient);
